import * as React from 'react'

import { Box, Skeleton, dimensions } from '@factorialco/deprecated-design-system'
import { times } from 'lodash'

interface Props {
  remainingNumber: number
}

export const LoadingSkeleton = ({ remainingNumber }: Props) => {
  const SkeletonBox = () => (
    <Box
      border={{ left: { color: 'grey300', style: 'solid', width: 's2' } }}
      style={{ marginLeft: dimensions.s24 }}
    >
      <Box paddingX="s24" paddingTop="s24" paddingBottom="s16">
        <Box flexDirection="row" gap="s8">
          <Skeleton width="s32" height="s32" isLoading />
          <Box gap="s4">
            <Skeleton width="s400" height="s16" isLoading />
          </Box>
          <Box paddingLeft="s32">
            <Skeleton width="s32" height="s8" isLoading />
          </Box>
        </Box>
        <Box paddingLeft="s40" paddingTop="s8" gap="s8">
          <Skeleton width="s400" height="s16" isLoading />
          <Skeleton width="s400" height="s16" isLoading />
        </Box>
      </Box>
    </Box>
  )

  return (
    <>
      {times(remainingNumber, (i) => (
        <SkeletonBox key={i} />
      ))}
    </>
  )
}
